import { Modal } from "components";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import LanguageDropdown from "components/dropdowns/reactselect/LanguageDropdown";
import LabelledDivRow from "components/LabelledDivRow";
import GenericMandatoryInput from "components/ValidatedFields/GenericMandatoryInput";
import { useValidate } from "formvalidation/hooks";
import { UseMutationResult } from "@tanstack/react-query";
import React from "react";
import { AxiosResponse } from "axios";
import { ButtonPrimary } from "components/Atoms/Button";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";

interface Props {
  addCustomAppLabelTranslation: (translationFor: server.dto.CustomAppLabel, language: server.dto.Language, customAppLabelTranslation: string) => void
  onClose: () => void
  clientId: number;
  customAppLabelTranslations: server.dto.CustomAppLabelTranslation[]
  mutation: UseMutationResult<AxiosResponse<server.dto.ApiResponseWrapper<server.dto.CustomAppLabelTranslation[]>>, unknown, server.dto.StoreCustomAppLabelTranslationInstruction, unknown>
}

const CustomAppLabelTranslationAddModal = (props: Props) => {
  const [translationFor, setTranslationFor] = React.useState(serverReference.customAppLabels[0]);
  const [language, setLanguage] = React.useState(serverReference.languages[0]);
  const [customAppLabelTranslation, setCustomAppLabelTranslation] = React.useState("");

  const isTranslationAlreadyChosen = props.customAppLabelTranslations.find(t => t.key === translationFor.value && t.language === language.value) != null;

  const translationAlreadyChosenValidation = useValidate({
    key: "translationAlreadyChosen",
    title: "This label and language combination is already translated",
    value: isTranslationAlreadyChosen,
    validate: async () => !isTranslationAlreadyChosen
  });

  return <Modal
    width="tiny"
    handleClose={props.onClose}
    isOpen
    title="Add custom translation"
  >
    <LabelledDivRow label="Translation for" rowRef={translationAlreadyChosenValidation.ref}>
      <BaseReactSelectDropdown
        excludeKeys={[]}
        options={serverReference.customAppLabels}
        getLabel={t => t.description}
        getValue={t => t.value}
        value={translationFor}
        onChange={t => setTranslationFor(t)}
        config={{
          isSearchable: true,
          hasError: translationAlreadyChosenValidation.error.hasError
        }}
      />
    </LabelledDivRow>

    <LabelledDivRow label="Language">
      <LanguageDropdown value={language} onChange={setLanguage} config={{ hasError: translationAlreadyChosenValidation.error.hasError }} />
    </LabelledDivRow>

    <LabelledDivRow label="Value">
      <GenericMandatoryInput value={customAppLabelTranslation} onChange={setCustomAppLabelTranslation} maxLength={255} validatorKey="customAppLabelTranslationMustHaveValue" title="Translation must have a value" />
    </LabelledDivRow>

    {props.mutation.isError && <SomethingUnexpectedHappenedMessageBox />}

    <ButtonPrimary
      label={RESX.Buttons.btnSave}
      onClick={() => props.addCustomAppLabelTranslation(translationFor, language, customAppLabelTranslation)}
      loading={props.mutation.isLoading}
      disabled={props.mutation.isLoading}
    />
  </Modal >
}

export default CustomAppLabelTranslationAddModal;